import { createSelector, Selector } from '@reduxjs/toolkit'
import { GlobalState } from '../store'
import { systemStoreSelector } from './storeSelectors'
import { EntityTypeEnum } from 'api'

export const initialSnapshotsLoadedSelector: Selector<GlobalState, boolean> = createSelector(
  systemStoreSelector,
  selector => selector.initialSnapshotsLoaded
)

export const createEntitySnapshotLoadedSelector = (entityTypeEnum: EntityTypeEnum): Selector<GlobalState, boolean> =>
  createSelector(systemStoreSelector, selector => selector.entitySnapshotsLoaded[entityTypeEnum])
